import { useState } from "react"

// Radio button options component
const RadioOption = ({ name, value, checked, onChange, label }) => (
    <label>
        <input
            type="radio"
            name={name}
            value={value}
            onChange={onChange}
            checked={checked}
        />
        {label}
    </label>
)

// Input field component
const InputField = ({ label, type = "text", placeholder, required = false }) => {
    try {
        return (
            <div className="feild">
                {label && (
                    <label>
                        {label}
                        {required && <span className="Refre-red">*</span>}
                    </label>
                )}
                <input type={type} placeholder={placeholder} />
            </div>
        );
    } catch (error) {
        console.error("Error rendering InputField:", error);
        return <div className="feild">Error loading field</div>;
    }
}

// Select field component
const SelectField = ({ label, options, required = false }) => (
    <div className="feild">
        {label && (
            <label>
                {label}
                {required && <span className="Refre-red">*</span>}
            </label>
        )}
        <select>
            {options.map((option, index) => (
                <option key={index} value={option.value || option}>
                    {option.label || option}
                </option>
            ))}
        </select>
    </div>
)

const AddPatientsModel = ({ onClose }) => {
    const labels = {
        addPatient: "Add Patient",
        patientRegistration: "Patient Registration Through ABHA Number",
        abhaAvailable: "ABHA Number available?",
        yes: "Yes",
        no: "No",
        registrationForm: "Registration Form",
        selectMethod: "Select Method",
        abhaAddress: "ABHA Address",
        abhaNumber: "ABHA Number",
        mobileNumber: "Mobile Number",
        enterAbhaAddress: "Enter ABHA Address",
        enterAbhaNumber: "Enter ABHA Number",
        enterMobileNumber: "Enter Mobile Number",
        adhar: "Adhar",
        mobile: "Mobile",
        consentConfirm: "I hereby confirm that the I have explained the below mentioned consent to the individual for the validation of ABHA Number and linking with MoHFW.",
        individualConsent: "Individual's consent for creation of ABHA Number",
        consentText: "I hereby declare that I am voluntarily sharing my ABHA Number with MoHFW programme.I am aware that MoHFWprogramme will authenticate my ABHA Number with ABDM system. I understand that this ABHA Number may be linkedwith the Identification number that MoHFW programme may generate",
        createAbhaNumber: "Create ABHA Number",
        chooseVerification: "Choose aadhaar verification method*",
        otp: "OTP",
        biometric: "Biometric",
        aadhaarDemographic: "Aadhaar Demographic",
        aadhaarNumber: "Aadhaar Number / Virtual ID *",
        abhaNumberTitle: "ABHA Number",
        abhaNumberDescription: "To generate ABHA Number, provide Aadhaar number for verification. An OTP will will be sent to the registered mobile number as per Aadhaar in OTP method. And in Biometric method need to capture finger of patient.",
        cancel: "Cancel",
        submit: "Submit",
        selectDistrict: "Select District",
        delhi: "Delhi",
        bihar: "Bihar",
        bangal: "Bangal",
        nhm: "NHM"
    };

    const [selectedMethod, setSelectedMethod] = useState('')
    const [patientRegister, setPatientRegister] = useState("yes")

    const handleMethodChange = (e) => {
        setSelectedMethod(e.target.value);
    };

    const handlePatientRegisterChange = (e) => {
        setPatientRegister(e.target.value);
    };

    return (
        <>

            <div className="modal fade show d-block verificationModel addPatientModel" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ background: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header border-bottom-0 ">
                            <div className="text-center headerText">
                                <h5 className="modal-title" id="exampleModalLabel">{labels.addPatient}</h5>
                            </div>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClose} />
                        </div>
                        <div className="modal-body">
                            <div className="patRegAbhaNum">
                                <h5>{labels.patientRegistration}</h5>
                                <h5>{labels.abhaAvailable}</h5>
                                <div className="feild seelctOnceNu">
                                    <label>
                                        <input type="radio" name="patientRegi" value="yes" onChange={(e) => setPatientRegister(e.target.value)} checked={patientRegister === "yes"} /> {labels.yes}
                                    </label>
                                    <label>
                                        <input type="radio" name="patientRegi" value="no" onChange={(e) => setPatientRegister(e.target.value)} checked={patientRegister === "no"} /> {labels.no}
                                    </label>
                                    <label>
                                        <input type="radio" name="patientRegi" value="registrationForm" onChange={(e) => setPatientRegister(e.target.value)} checked={patientRegister === "registrationForm"} /> {labels.registrationForm}
                                    </label>
                                </div>
                                {patientRegister === 'yes' && (
                                    <div className="boxRegABHAnum isabhaNum">
                                        <div className="isSlectedBox">
                                            <div className="selectedFeildsChose">
                                                <div className="selctedImgWithFeilds">
                                                    <img src={"/images/PMNDP/icon_health_id.png"} alt="Health ID Icon" />
                                                </div>
                                                <div className="feild">
                                                    <select onChange={handleMethodChange}>
                                                        <option>{labels.selectMethod}</option>
                                                        <option value={'ABHA Address'}>{labels.abhaAddress}</option>
                                                        <option value={'ABHA Number'}>{labels.abhaNumber}</option>
                                                        <option value={'Mobile Number'}>{labels.mobileNumber}</option>
                                                    </select>
                                                </div>
                                                {selectedMethod === 'ABHA Address' && (
                                                    <div className="selectedAfter abhaAdress">
                                                        <div className="feild">
                                                            <input type="text" placeholder={labels.enterAbhaAddress} />
                                                        </div>
                                                        <div className="feild">
                                                            <select>
                                                                <option>Select Method</option>
                                                                <option value={'ABHA Address'}>Adhar </option>
                                                                <option value={'ABHA Number'}>Mobile</option>
                                                            </select>
                                                        </div>
                                                    </div>)}
                                                {selectedMethod === 'ABHA Number' && (
                                                    <div className="selectedAfter abhaNumber">
                                                        <div className="feild">
                                                            <input type="text" placeholder={labels.enterAbhaNumber} />
                                                        </div>
                                                        <div className="feild">
                                                            <select>
                                                                <option>Select Method</option>
                                                                <option value={'ABHA Address'}>Adhar </option>
                                                                <option value={'ABHA Number'}>Mobile</option>
                                                            </select>
                                                        </div>
                                                    </div>)}
                                                {selectedMethod === 'Mobile Number' && (
                                                    <div className="selectedAfter mobileNum">
                                                        <div className="feild">
                                                            <input type="text" placeholder={labels.enterMobileNumber} />
                                                        </div>

                                                    </div>
                                                )}
                                            </div>
                                            <div className="acceptCheckBoxAddPatent">
                                                <label>
                                                    <input type="checkbox" />
                                                    <span>{labels.consentConfirm}</span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="individualConsent">
                                            <h4>{labels.individualConsent}</h4>
                                            <p>{labels.consentText}</p>
                                        </div>
                                    </div>
                                )}

                                {patientRegister === 'no' && (
                                    <div className="boxRegABHAnum notabhaNum">
                                        <div className="craeetAbhaNum">
                                            <label>
                                                <input type="radio" />
                                                <span>{labels.createAbhaNumber}</span>
                                            </label>
                                        </div>
                                        <div className="verificatioMethod">
                                            <h5>{labels.chooseVerification}</h5>
                                            <div className="feild seelctOnceNu">
                                                <label>
                                                    <input type="radio" name="verificationMethod" /> {labels.otp}
                                                </label>
                                                <label>
                                                    <input type="radio" name="verificationMethod" /> {labels.biometric}
                                                </label>
                                                <label>
                                                    <input type="radio" name="verificationMethod" /> {labels.aadhaarDemographic}
                                                </label>
                                            </div>
                                        </div>
                                        <div className="abhaNumberVerPro">
                                            <h5>{labels.abhaNumberTitle}</h5>
                                            <p>{labels.abhaNumberDescription}</p>
                                        </div>
                                        <div className="isSlectedBox">
                                            <div className="selectedFeildsChose">
                                                <div className="selctedImgWithFeilds">
                                                    <img src={"/images/PMNDP/icon_health_id.png"} alt="Health ID Icon" />
                                                </div>
                                                <div className="feild">
                                                    <label>{labels.aadhaarNumber}</label>
                                                    <input type="text" />
                                                </div>
                                            </div>
                                            <div className="acceptCheckBoxAddPatent">
                                                <label>
                                                    <input type="checkbox" />
                                                    <span>I hereby confirm that I have explained the below mentioned consent process to the individual for the creation of the ABHA Number using the individual's Aadhaar/ Virtual ID details.</span>
                                                </label>
                                                <label>
                                                    <input type="checkbox" />
                                                    <span>I am voluntarily sharing my Aadhaar Number / Virtual ID issued by the Unique Identification Authority of India (UIDAI) and my demographic information for the purpose of creating an Ayushman Bharat Health Account number (ABHA number) and Ayushman Bharat Health Account address (ABHA Address).I authorize NHA to use my Aadhaar number / Virtual ID for performing Aadhaar based authentication with UIDAI as per the provisions of the Aadhaar (Targeted Delivery of Financial and other Subsidies, Benefits and Services) Act, 2016 for the aforesaid purpose. I understand that UIDAI will share my e-KYC details, or response of "Yes" with NHA upon successful authentication.</span>
                                                </label>
                                                <label>
                                                    <input type="checkbox" />
                                                    <span>I intend to create Ayushman Bharat Health Account Number (ABHA number) and Ayushman Bharat Health Account address (ABHA Address) using document other than Aadhaar.</span>
                                                </label>
                                                <label>
                                                    <input type="checkbox" />
                                                    <span>
                                                        I consent to usage of my ABHA address and ABHA number for linking of my legacy (past) government health records and those which will be generated during this encounter.</span>
                                                </label>
                                                <label>
                                                    <input type="checkbox" />
                                                    <span>I authorize the sharing of all my health records with healthcare provider(s) for the purpose of providing healthcare services to me during this encounter.</span>
                                                </label>
                                                <label>
                                                    <input type="checkbox" />
                                                    <span>I consent to the anonymization and subsequent use of my government health records for public health purposes.</span>
                                                </label>
                                                <label className="ps-4">
                                                    <input type="checkbox" />
                                                    <span>I confirm that I have duly informed and explained the beneficiary of the contents of consent for aforementioned purposes.</span>
                                                </label>
                                                <label className="ps-4">
                                                    <input type="checkbox" />
                                                    <span>I have been explained about the consent as stated above and hereby provide my consent for the aforementioned purposes.</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {patientRegister === 'regiterationForm' && (
                                    <div className="patientsRegistrationForm">
                                        <div className="patentProfile patentsRegFormBox">
                                            <div className="innerBoxesFeilds">
                                                <div className="row">
                                                    <div className="col-xs-12 col-md-4">
                                                        <div className="profilePhoto text-center">
                                                            <img src={"/images/PMNDP/icon_health_id.png"} alt="Profile Photo" />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-md-4">
                                                        <div className="feild">
                                                            <label>ABHA Number</label>
                                                            <input type="text" />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-md-4">
                                                        <div className="feild">
                                                            <label>ABHA Addrress</label>
                                                            <input type="text" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="patentsRegFormBox">
                                            <h5>Personal Details</h5>
                                            <div className="innerBoxesFeilds">
                                                <div className="row">
                                                    <div className="col-xs-12 col-md-6">
                                                        <div className="feild">
                                                            <label>Registration Date<span className="Refre-red">*</span></label>
                                                            <input type="date" />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-md-6">
                                                        <div className="feild">
                                                            <label>Patient Name<span className="Refre-red">*</span></label>
                                                            <input type="text" />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-md-6">
                                                        <div className="feild">
                                                            <label>Date Of Birth<span className="Refre-red">*</span></label>
                                                            <input type="date" />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-md-6">
                                                        <div className="feild">
                                                            <label>Age<span className="Refre-red">*</span></label>
                                                            <input type="text" />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-md-6">
                                                        <div className="feild">
                                                            <label>Patient Height<span className="Refre-red">*</span></label>
                                                            <input type="text" />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-md-6">
                                                        <div className="feild">
                                                            <label>Patient Weight<span className="Refre-red">*</span></label>
                                                            <input type="text" name="patient_weight" />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-md-6">
                                                        <div className="feild">
                                                            <label>Gender<span className="Refre-red">*</span></label>
                                                            <select>
                                                                <option value="Male">Male</option>
                                                                <option value="Female">Female</option>
                                                                <option value="Transgender">Transgender</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="patentsRegFormBox">
                                            <h5>Contact Details</h5>
                                            <div className="innerBoxesFeilds">
                                                <div className="row">
                                                    <div className="col-xs-12 col-md-6">
                                                        <div className="feild">
                                                            <label>Mobile Number<span className="Refre-red">*</span></label>
                                                            <input type="text" />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-md-6">
                                                        <div className="feild">
                                                            <label>Email ID</label>
                                                            <input type="text" />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-md-6">
                                                        <div className="feild">
                                                            <label>Emergency Contact No.<span className="Refre-red">*</span></label>
                                                            <input type="text" />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-md-6">
                                                        <div className="feild">
                                                            <label>Address<span className="Refre-red">*</span></label>
                                                            <input type="text" />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-md-6">
                                                        <div className="feild">
                                                            <label>State<span className="Refre-red">*</span></label>
                                                            <select>
                                                                <option>{labels.delhi}</option>
                                                                <option>{labels.bihar}</option>
                                                                <option>{labels.bangal}</option>
                                                                <option>Uttar Pradesh</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-md-6">
                                                        <div className="feild">
                                                            <label>District<span className="Refre-red">*</span></label>
                                                            <select>
                                                                <option>{labels.selectDistrict}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="patentsRegFormBox">
                                            <h5>Dialysis Details</h5>
                                            <div className="innerBoxesFeilds">
                                                <div className="row">
                                                    <div className="col-xs-12 col-md-6">
                                                        <div className="feild">
                                                            <label>Dialysis Support Type <span className="Refre-red">*</span></label>
                                                            <select>
                                                                <option></option>
                                                                <option>{labels.nhm}</option>
                                                                <option>State</option>
                                                                <option>Other</option>

                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-md-6">
                                                        <div className="feild">
                                                            <label>Procedure Type<span className="Refre-red">*</span></label>
                                                            <select>
                                                                <option>Negative</option>
                                                                <option>HIV</option>
                                                                <option>HBV</option>
                                                                <option>HCV</option>
                                                                <option>HIV/HCV/HBV</option>
                                                                <option>Double Positive</option>

                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-md-6">
                                                        <div className="feild">
                                                            <label>Dialysis Mode<span className="Refre-red">*</span></label>
                                                            <div className="radioProfile d-flex ">
                                                                <label>
                                                                    <input type="radio" name="dylasismode" /> Hemodylasis
                                                                </label>
                                                                <label>
                                                                    <input type="radio" name="dylasismode" /> Permoniyal dylasis
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-md-6">
                                                        <div className="feild">
                                                            <label>Recomended dylasis count (per week)<span className="Refre-red">*</span></label>
                                                            <input type="text" />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-md-12">
                                                        <div className="feild">
                                                            <label>
                                                                <input type="checkbox" />
                                                                <span className="ps-2">Patient is counsiled for using Mobile application</span></label>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                        <div className="patentsRegFormBox">
                                            <h5>Other Details</h5>
                                            <div className="innerBoxesFeilds">
                                                <div className="row">
                                                    <div className="col-xs-12 col-md-6">
                                                        <div className="feild">
                                                            <label>Below Poverty (BPL)<span className="Refre-red">*</span></label>
                                                            <div className="bplFeilds">
                                                                <label><input type="radio" /> Yes</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-12 col-md-6">
                                                        <div className="feild">
                                                            <label>BPL Option<span className="Refre-red">*</span></label>
                                                            <select>
                                                                <option>Select BPL Option</option>
                                                                <option>Ayushman Card</option>
                                                                <option>PM-JAY Sehat Scheme</option>
                                                                <option>Pink Ration Card</option>
                                                                <option>BPL Card</option>
                                                                <option>EWS Category</option>

                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="cancel" onClick={onClose} >{labels.cancel}</button>
                            <button className="submit">{labels.submit}</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddPatientsModel